export const ACCESS_TOKEN_LENGTH = 86
export const NEXT_PUBLIC_IMAGE = process.env.NEXT_PUBLIC_IMAGE_URL ?? ''